import React from 'react';
//import $ from 'jquery';
import api from '../../../services/api';
import { Modal } from 'react-bootstrap';
import querystring from 'querystring';
import loadingGif from '../../../img/loading-gif.gif';
import ReactInputMask from 'react-input-mask';
import moment from 'moment';

class PontoVendaForm extends React.Component {
	constructor(props) {
		super(props);

		this.resetForm = this.resetForm.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChangeInput = this.handleChangeInput.bind(this);
		this.setValidations();

		this.state = {
			texto: '',
			tipo: '',
			status: '',
			expiracao: '',
			criado: '',
			alterado: '',
		};

		if (this.props.item) {
			const item = this.props.item;
			this.state = {
				texto: item.texto,
				tipo: item.tipo,
				status: item.status,
				expiracao: moment(item.expiracao).format('DD/MM/YYYY H:mm'),
				criado: item.criado,
				alterado: item.alterado,
				id: item.id,
			};
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.item !== prevProps.item) {
			const item = this.props.item;

			this.setState({
				texto: item.texto,
				tipo: item.tipo,
				status: item.status,
				expiracao: moment(item.expiracao).format('DD/MM/YYYY H:mm'),
				criado: item.criado,
				alterado: item.alterado,
				id: item.id,
			});
		}
	}

	null2Empty(val) {
		if (val == null) return '';
		return val;
	}

	cancelForm() {
		if (this.props.item) {
			const item = this.props.item;

			this.setState({
				texto: item.texto,
				tipo: item.tipo,
				status: item.status,
				expiracao: moment(item.expiracao).format('DD/MM/YYYY H:mm'),
				criado: item.criado,
				alterado: item.alterado,
				id: item.id,
			});
		} else {
			this.resetForm();
		}
	}

	resetForm() {
		this.setState({
			texto: '',
			tipo: '',
			status: '',
			expiracao: '',
			criado: '',
			alterado: '',
		});
	}

	handleChangeInput(event) {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value,
		});
	}

	showErrorMessage(key) {
		if (!this.validations[key] || this.validations[key].valid !== false) return;
		return this.validations[key].message;
	}

	async handleSubmit(e, setModalVisible) {
		const self = this;
		e.preventDefault();

		//console.log(this.state);

		if (!this.validate()) {
			this.forceUpdate();
			return;
		}

		const qsData = querystring.stringify(this.state);
		////console.log(qsData);

		self.setState({
			loading: true,
		});
		//console.log(self.state.loading);

		const options = {
			//method: 'POST',
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
			//data: x,
			//url: '/admin/unidade',
		};

		const response = await api.post('/admin/restricao', qsData, options);

		const { data, status } = response;

		////console.log(data);
		////console.log(status);
		//console.log(data);
		if (data === false) {
			alert('Solicitação inválida');
			this.setState({ loading: false });

			return;
		}

		if (status === 200 && data.id) {
			if (!self.state.id) {
				//	$('#' + self.props.elementId + 'Elem')[0].reset();
			}

			if (typeof self.props.callback == 'function') {
				self.props.callback(data);
				setModalVisible(false);
			}

			//$('#' + self.props.elementId).modal('hide');
		} else {
			var keys = Object.keys(data);
			var msgs = '';
			for (var i = 0; i < keys.length; i++) {
				msgs += data[keys[i]] + '\n';
			}

			alert(msgs);
			this.setState({ loading: false });

			return;
		}
		this.setState({ loading: false });
		//this.setState({ loading: false });
	}

	validate() {
		var valid = true;
		var keys = Object.keys(this.validations);

		for (var i = 0; i < keys.length; i++) {
			this.validations[keys[i]].valid = this.validations[keys[i]].validator(
				this.state[keys[i]]
			);
			if (!this.validations[keys[i]].valid) {
				valid = false;
				continue;
			}
		}

		return valid;
	}

	setValidations() {
		this.validations = {
			tipo: {
				valid: null,
				message: 'tipo inválido',
				validator: (value) => {
					return Boolean(value && String(value).length > 0);
				},
			},
			status: {
				valid: null,
				message: 'status inválido',
				validator: (value) => {
					return ['0', '1', '2'].indexOf(String(value)) > -1;
				},
			},
			texto: {
				valid: null,
				message: 'texto  inválida',
				validator: (value) => {
					return Boolean(value && String(value).length > 0);
				},
			},
			expiracao: {
				valid: null,
				message: 'expiracao inválida',
				validator: (value) => {
					return Boolean(value && String(value).length > 0);
				},
			},
		};
	}

	render() {
		const props = this.props;
		const restricao = this.state;
		const { modalVisible, setModalVisible } = props;
		////console.log(restricao);

		return (
			<Modal
				show={modalVisible}
				onHide={() => {
					setModalVisible(false);
				}}>
				<Modal.Header>
					<h2 className='modal-title'>
						{props.item ? 'Editar Restrição' : 'Nova Restrição'}
					</h2>
				</Modal.Header>
				<Modal.Body>
					<form
						id={props.elementId + 'Elem'}
						onSubmit={(e) => {
							this.handleSubmit(e, setModalVisible);
							//setModalVisible(false);
						}}>
						<div className='modal-body'>
							<div className='form-group'>
								<p>{restricao.loading}</p>
								<label>Tipo</label>
								<select
									className='form-control'
									name='tipo'
									value={restricao.tipo}
									onChange={this.handleChangeInput}>
									<option value=''>Selecione</option>
									<option value='uc'>{'uc'.toUpperCase()}</option>
									<option value='doc'>{'doc'.toUpperCase()}</option>
									<option value='email'>{'Email'}</option>
								</select>
								<span className='text-danger'>
									{this.showErrorMessage('tipo')}
								</span>
							</div>

							<div className='form-group'>
								<label>Texto</label>
								<input
									className='form-control'
									type='text'
									name='texto'
									value={restricao.texto}
									onChange={this.handleChangeInput}
								/>
								<span className='text-danger'>
									{this.showErrorMessage('texto')}
								</span>
							</div>

							<div className='form-group'>
								<label>Situação</label>
								<select
									className='form-control'
									name='status'
									value={restricao.status}
									onChange={this.handleChangeInput}>
									<option value=''>Selecione</option>
									<option value='0'>Inativo</option>
									<option value='1'>Temporário</option>
									<option value='2'>Permanente</option>
								</select>
								<span className='text-danger'>
									{this.showErrorMessage('status')}
								</span>
							</div>

							<div className='form-group'>
								<label>Expiração</label>
								<ReactInputMask
									className='form-control'
									type='text'
									name='expiracao'
									value={restricao.expiracao}
									onChange={this.handleChangeInput}
									inputMode='numeric'
									mask='99/99/9999 99:99'
								/>
								<span className='text-danger'>
									{this.showErrorMessage('expiracao')}
								</span>
							</div>
						</div>
						<div className='modal-footer'>
							<button
								type='button'
								onClick={(e) => {
									e.preventDefault();

									this.cancelForm();

									setModalVisible(false);
								}}
								className='btn btn-light border'
								data-dismiss='modal'>
								Cancelar
							</button>
							<button type='submit' className='btn btn-primary'>
								{restricao.loading ? (
									<img className='loadingImg' src={loadingGif} alt='loading' />
								) : (
									'Salvar'
								)}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
		);
	}
}

export default PontoVendaForm;
